class ParallaxScroll extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('.parallax-scroll__panel'));
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.ticking = false;

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.15 });
    this.panels.forEach((panel) => this.observer.observe(panel));

    this.hasTransformPanels = this.panels.some(
      (panel) => panel.querySelector('[data-parallax-style="transform"]') && !this.reduceMotion
    );

    if (this.hasTransformPanels) {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.hasTransformPanels) {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      }
    });
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.updateParallax();
      this.ticking = false;
    });
  }

  updateParallax() {
    const viewportHeight = window.innerHeight;

    this.panels.forEach((panel) => {
      const media = panel.querySelector('[data-parallax-style="transform"]');
      if (!media) return;

      const rect = panel.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const img = media.querySelector('.parallax-scroll__img');
      if (!img) return;

      const speed = parseFloat(media.dataset.parallaxSpeed || '30') / 100;
      const progress = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
      const offset = progress * speed * viewportHeight * -0.5;

      img.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
    });
  }
}

customElements.define('parallax-scroll', ParallaxScroll);
